/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Beepluginenabled2Inputs */

const en_entity_beepluginenabled2 = /** @type {(inputs: Entity_Beepluginenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bee Plugin Enabled`)
};

const de_entity_beepluginenabled2 = /** @type {(inputs: Entity_Beepluginenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bee-Plugin aktiviert`)
};

/**
* | output |
* | --- |
* | "Bee Plugin Enabled" |
*
* @param {Entity_Beepluginenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_beepluginenabled2 = /** @type {((inputs?: Entity_Beepluginenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Beepluginenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_beepluginenabled2(inputs)
	return de_entity_beepluginenabled2(inputs)
});
export { entity_beepluginenabled2 as "entity_beePluginEnabled" }